import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { RouteReuseService } from './route-reuse.service';

export class CustomReuseStrategy implements RouteReuseStrategy {
  constructor(private reuseService: RouteReuseService) {}

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const path = this.getFullPath(route);
    return this.reuseService.shouldPreserve(path);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    const path = this.getFullPath(route);
    this.reuseService.storeHandle(path, handle);
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const path = this.getFullPath(route);
    return this.reuseService.hasStoredHandle(path);
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const path = this.getFullPath(route);
    const handle = this.reuseService.getHandle(path);
    if (handle) {
      this.reuseService.markAsReattaching(path);
      this.reuseService.notifyReattach(path);
    }
    return handle;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  private getFullPath(route: ActivatedRouteSnapshot): string {
    const groups: string[][] = [];
    let current: ActivatedRouteSnapshot | null = route;
    while (current) {
      const nodeSegments = current.url.map(seg => seg.path);
      if (nodeSegments.length) {
        groups.unshift(nodeSegments);
      }
      current = current.parent;
    }
    return groups.flat().join('/');
  }
}
